import styled from '@emotion/styled';
import { ThemeColors } from '@theme/foundations/colors';

export const StyledWeekdays = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const StyledDay = styled.div<{ isActive: boolean; gap: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin-left: ${(props) => props.gap}px;
  color: white;
  background-color: ${(props) =>
    props.isActive ? ThemeColors.primary[500] : ThemeColors.neutral[400]};
`;
